
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";


const securityPermissionAPI = createApi({
    reducerPath: 'securityPermissionAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllPagesByRoleId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Security/GetAllPagesByRoleId/?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllRoles: builder.query({
            query: () => ({
                url:"/Roles/GetAllRoles",
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addSecurityPermissions: builder.mutation({
            query: (details) => ({
                url: '/Security/AddSecurityPermissions',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})

export const {
    useLazyGetAllRolesQuery,
    useLazyGetAllPagesByRoleIdQuery,
    useAddSecurityPermissionsMutation,
} = securityPermissionAPI;

export default securityPermissionAPI;